import React from 'react'
import PieChart from 'highcharts-react-official'
import Highcharts from 'highcharts/highcharts'

Highcharts.setOptions({ lang: { thousandsSep: ',' } });

export default function SummaryDonut({ data }) {
    const totalTarget = +data?.TotalTarget || 0
    const rainyActual = +data?.RainyActual || 0
    const dryActual = +data?.DryActual || 0
    // ส่วนที่ยังไม่ได้ผลิตตามเป้าหมาย = กำลังดำเนินการ
    const remaining = Math.max(totalTarget - rainyActual - dryActual, 0)

    // ต้นปีงบที่ยังไม่มีทั้งแผนและผลผลิต — ไม่วาดกราฟกันแสดง NaN%
    if (rainyActual + dryActual + remaining === 0) {
        return (
            <div style={{ textAlign: 'center', paddingTop: '30px' }}>
                <div style={{ fontSize: '15px', fontWeight: 'bold' }}>ผลการผลิตรวม</div>
                <div style={{ color: '#595959', marginTop: '30px' }}>ยังไม่มีข้อมูลในปีงบประมาณนี้</div>
            </div>
        )
    }

    const options = {
        chart: {
            type: 'pie',
            height: 175,
            backgroundColor: 'transparent',
            spacing: [0, 0, 0, 0],
        },
        title: {
            text: 'ผลการผลิตรวม',
            style: { fontSize: '15px', fontWeight: 'bold' }
        },
        tooltip: {
            pointFormatter: function () {
                return `<b>${this.percentage?.toFixed(1)}%</b>`
            }
        },
        plotOptions: {
            pie: {
                innerSize: '60%',
                dataLabels: {
                    enabled: true,
                    format: '{point.percentage:.0f}%',
                    distance: 8,
                    style: { fontSize: '12px', textOutline: 'none' }
                },
                showInLegend: true,
            }
        },
        legend: {
            enabled: true,
            itemStyle: { fontSize: '10px' },
            symbolRadius: 0,
            itemDistance: 5,
        },
        series: [{
            name: 'ผลการผลิตรวม',
            data: [
                { name: 'ฤดูฝน', y: rainyActual, color: '#ED7D31' },
                { name: 'ฤดูแล้ง', y: dryActual, color: '#FFC000' },
                { name: 'กำลังดำเนินการ', y: remaining, color: '#70AD47' },
            ]
        }],
        credits: { enabled: false },
    }

    return (
        <PieChart options={options} highcharts={Highcharts} />
    )
}
